import {AVAILABLE_NUM_SEARCH_RESULTS, LATEST_OBJECTS_SHOW_LIMIT, ObjectTypeId} from "../../constants";
import {global} from "../../appContext";
import {storeObservable} from "../../util/sessionstore";
import {nsSettings} from "./fn";
import {PermissionValidator} from "../../auth/PermissionValidator";
import {IRouteDefinitionParams} from "../../index";
import {nsRoute} from "../../util/route";
import {KOSubscriptionTracker} from "../../util/KOSubscriptionTracker";
import {isNaN} from "lodash";
import ParsedRouteDataDecorator = nsRoute.ParsedRouteDataDecorator;
import discardAllSettings = nsSettings.discardAllSettings;
import detailsHtml from './details.html?raw';

export let template: string = detailsHtml;

export class viewModel extends ParsedRouteDataDecorator {
    private readonly cssBlockFullWidth: KnockoutObservable<boolean> = storeObservable('css.block.fullwidth');
    private readonly numSearchResults: KnockoutObservable<number> = storeObservable('num.search.results');
    private readonly numRulesetDerivedValues: KnockoutObservable<number> = storeObservable('num.ruleset.derived.values');
    private readonly productionWarning: KnockoutObservable<boolean> = storeObservable('production.warning');
    private readonly showLimit: KnockoutObservable<number> = storeObservable('latest.objects.show.limit');
    private readonly latestObjectsAutomatic: KnockoutObservable<boolean> = storeObservable('latest.objects.automatic');
    private readonly showSuperAdminEmulating: KnockoutObservable<boolean> = storeObservable('show.super.adm.emulating');
    private readonly storeLimit: KnockoutObservable<number> = storeObservable('latest.objects.store.limit');
    private readonly useConsole: KnockoutObservable<number> = storeObservable('should.use.console');
    private readonly prefixTranslations: KnockoutObservable<number> = storeObservable('prefix.translation');
    private readonly showTranslationKey: KnockoutObservable<number> = storeObservable('show.translation.key');
    private readonly showComponentName: KnockoutObservable<boolean> = storeObservable('show.component.name');
    private readonly useEadmExpressionBuilderInEhub: KnockoutObservable<boolean> = storeObservable('eadm.expressionbuilder.ehub');

    AVAILABLE_NUM_SEARCH_RESULTS = AVAILABLE_NUM_SEARCH_RESULTS;

    ObjectTypeId = ObjectTypeId;

    private pv: PermissionValidator = global.permissionValidator;
    private readonly kosub: KOSubscriptionTracker = new KOSubscriptionTracker();

    private readonly isEmulated = global.loginManager.isEmulated

    constructor(params: IRouteDefinitionParams) {
        super(params);
        this.kosub.subscribe(this.showLimit, (val: any) => {
            let v = parseInt(val);
            if (isNaN(v)) {
                this.showLimit(LATEST_OBJECTS_SHOW_LIMIT);
            } else {
                this.showLimit(v);
            }
        })
    }

    private onRestoreFactorySettingsClick = discardAllSettings

    private onDeleteCacheClick() {
        global.cacheManager.removeCache()
    }

}
